export class DefaultRecord {
  public dnsRecords: string[];
  public nameservers: string[];
  public tenwebNs: string[];
  public server: string;
  public hasCertificate: number;

  constructor(data) {
    this.dnsRecords = data.dns_records;
    this.nameservers = data.nameservers;
    this.tenwebNs = data.tenweb_ns;
    this.server = data.server;
    this.hasCertificate = data.has_certificate;
  }
}
